import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/people/DonorDemographicsReport.jsx
// — renamed Donor -> Member, endpoint moved to /reports/memberships/member-demographics
// (MembershipReportController::memberDemographics()).
const COLUMNS: ReportColumn[] = [
  { key: 'age_band', label: 'Age Band' },
  { key: 'gender', label: 'Gender' },
  { key: 'count', label: 'Count', align: 'right' },
];

export function MemberDemographicsReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Member Demographics"
      description="Member breakdown by age band and gender."
      endpoint="/reports/memberships/member-demographics"
      columns={COLUMNS}
      filters={['category']}
      categoryOptions={listOptions(lists, 'member_type')}
    />
  );
}
